// extracted by mini-css-extract-plugin
module.exports = {"input":"ChangeAvatarButton_input__17Bar","btn":"ChangeAvatarButton_btn__1taz3","label":"ChangeAvatarButton_label__5wkpI","icon":"ChangeAvatarButton_icon__2H0cA"};